import { useEffect, useRef } from 'react';
import useBarcodeScanStore from '../store/barcodeScanStore';
import useScanTargetStore from '../store/scanTargetStore';
import { processBarcodeScan } from '../services/barcodeScanProcessor';

export default function useAutoAddBarcodes() {
  const items = useBarcodeScanStore(s => s.items);
  const loading = useBarcodeScanStore(s => s.loading);
  const orderId = useScanTargetStore(s => s.orderId);
  const registered = useScanTargetStore(s => s.barcodeHandler !== null);
  const targetKey = registered ? String(orderId ?? 'new') : null;

  const previousRef = useRef<Set<number>>(new Set());
  const lastTargetRef = useRef<string | null>(null);
  const awaitingBaselineRef = useRef(false);

  useEffect(() => {
    if (targetKey !== lastTargetRef.current) {
      lastTargetRef.current = targetKey;
      awaitingBaselineRef.current = targetKey !== null;
    }
    if (awaitingBaselineRef.current) {
      if (loading) return;
      previousRef.current = new Set(items.map(item => item.id));
      awaitingBaselineRef.current = false;
      return;
    }

    const current = new Set(items.map(item => item.id));
    const fresh = items.filter(item => !previousRef.current.has(item.id) && !item.outcome);
    previousRef.current = current;
    if (fresh.length === 0 || !registered) return;

    let autoAdd = true;
    try {
      const saved = localStorage.getItem('scanBufferAutoAdd');
      autoAdd = saved === null || saved === 'true';
    } catch {}
    if (!autoAdd) return;

    void (async () => {
      for (const scan of fresh) await processBarcodeScan(scan);
    })();
  }, [items, loading, registered, targetKey]);
}
